import { render, staticRenderFns } from "./InterviewDetail.vue?vue&type=template&id=25937482&scoped=true"
import script from "./InterviewDetail.vue?vue&type=script&lang=js"
export * from "./InterviewDetail.vue?vue&type=script&lang=js"
import style0 from "./InterviewDetail.vue?vue&type=style&index=0&id=25937482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25937482",
  null
  
)

export default component.exports